import { render } from "./AGBSection.vue?vue&type=template&id=3c8ebd00&scoped=true"
import script from "./AGBSection.vue?vue&type=script&lang=js"
export * from "./AGBSection.vue?vue&type=script&lang=js"

import "./AGBSection.vue?vue&type=style&index=0&id=3c8ebd00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8ebd00"]])

export default __exports__